import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import Contratos from "@/pages/admin/Contratos";
import { pageHead } from "@/lib/seo";

const busca = z.object({
  filtro: z.enum(["todos", "aguardando", "assinados", "rascunhos", "cancelados"]).optional().catch(undefined),
  anexar: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute("/admin/contratos/")({
  validateSearch: busca,
  head: () => pageHead({ title: "Contratos | Painel", path: "/admin/contratos", noindex: true }),
  component: Contratos,
});
